<template lang="html">
  <div class="row">
    <div class="col-4 col-sm-4 col-md-4" >
      <input
        class="form-control"
        v-model="day"
        placeholder="День"
        v-mask="'##'"
        @change = "dayChange"
      />

    </div>
    <div class="col-4 col-sm-4 col-md-4" >
      <b-form-select v-model="month" @input="onChange" :options="months" />
    </div>
    <div class="col-4 col-sm-4 col-md-4" @change="onChange" >
      <input
        class="form-control"
        type="text"
        v-model="year"
        v-mask="'####'"
        placeholder="Год"
      />
    </div>
  </div>
</template>

<script>
const months = [
  { value: null, text: 'Месяц', disabled: true },
  { value: '01', text: 'Январь' },
  { value: '02', text: 'Февраль' },
  { value: '03', text: 'Март' },
  { value: '04', text: 'Апрель' },
  { value: '05', text: 'Май' },
  { value: '06', text: 'Июнь' },
  { value: '07', text: 'Июль' },
  { value: '08', text: 'Август' },
  { value: '09', text: 'Сентябрь' },
  { value: '10', text: 'Октябрь' },
  { value: '11', text: 'Ноябрь' },
  { value: '12', text: 'Декабрь' }
]

export default {
  props: ['value'],
  data () {
    return {
      day: '',
      month: null,
      year: '',
      months: months
    }
  },
  watch: {
    value (date) {
      [ this.day, this.month, this.year ] = date.split('.')
    }
  },
  methods: {
    dayChange (e) {
      this.day = this.formatDay(e.target.value)
      this.onChange()
    },
    formatDay (val) {
      if (val === '0') {
        return '01'
      } else if (val > 31) {
        return 31
      } else if (parseInt(val) < 10) {
        return '0' + val
      } else {
        return val
      }
    },
    onChange () {
      if (this.day && this.month && this.year) {
        this.$emit('input', this.day + '.' + this.month + '.' + this.year)
      } else {
        // this.$emit('input', '')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// InlineDatepicker.vue?a7d2320a